<template>
    <tbody>
        <tr
            v-for="(item, index) in localItems"
            :key="item.id"
            :draggable="!isSorting"
            @dragstart="handleDragStart($event, index)"
            @dragover.prevent
            @drop="handleDrop($event, index)"
        >
            <slot :item="item" :index="index" />
        </tr>
    </tbody>
</template>

<script>
import { EventBus } from '@/js/event-bus.js'
export default {
    props: {
        items: {
            type: Array,
            required: true
        },
        sortEndpoint: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            isSorting: false,
            localItems: [...this.items]
        };
    },
    watch: {
        items: {
            handler(newVal) {
                this.localItems = [...newVal];
            },
            deep: true
        }
    },
    methods: {
        handleDragStart(event, index) {
            event.dataTransfer.setData('fromIndex', index);
        },
        handleDrop(event, toIndex) {
            const fromIndex = parseInt(event.dataTransfer.getData('fromIndex'));

            if (fromIndex === toIndex) {
                return;
            }

            const reordered = [...this.localItems];
            const moved = reordered.splice(fromIndex, 1)[0];
            reordered.splice(toIndex, 0, moved);

            // Update order
            reordered.forEach((item, i) => {
                item.order = i + 1;
            });

            this.localItems = reordered;
            this.$emit('reordered', reordered);

            const updatedOrderList = reordered.map(({ id, order }) => ({ id, order }));
            this.handleSorting(updatedOrderList);
        },

        handleSorting(updatedOrderList) {
            this.isSorting = true;
            this.$http
                .post(this.sortEndpoint, updatedOrderList)
                .then(({ data }) => {
                    EventBus.$emit('show-success', 'Sorted successfully.');
                })
                .catch(err => {
                    EventBus.$emit('show-error', err);
                })
                .finally(() => {
                    this.isSorting = false;
                });
        }
    }

}
</script>